// extracted by mini-css-extract-plugin
export default {"referralCodePopUp":"ReferralCodePopup__referralCodePopUp__aOxV9"};